import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Tabs, Tab, Form, Button, Breadcrumb } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll";
import { navigate } from "@reach/router";

import {CustomLinks} from "../common/utils";

import "./PersonLinks.scss"
// Header component

const PersonLinks = (props) => {
  return (
    <React.Fragment>
      <section className="Person-nav sample">
        <Container>
          <Row>
            <Col>
              <div className="sm-menu-list d-lg-none">
                <Link to={CustomLinks.our_people+CustomLinks.find_team}><span className="sm-text">  &lt;  back to People </span></Link>
              </div>
              <div className="breadcrumb d-none d-lg-flex">
                <Breadcrumb>
                  <li className="breadcrumb-item"><Link to='/'>Home</Link></li>
                  <li className="breadcrumb-item"><Link to={`${CustomLinks.our_people}${CustomLinks.find_team}/`}>our people</Link></li>
                  <li className="breadcrumb-item active"><a>{props.page_title}</a></li>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default PersonLinks;
